import { useQuery } from "@tanstack/react-query";
import { sendErrorReport } from "../../../utils/reporting";
import { fetchFlights } from "v2/api/flights";
import { extractFlightSelectorFlightData } from "../serializers/intake-funnel";
import { Cookies } from "react-cookie";
import { TURNSTILE_COOKIE_NAME } from "../security/TurnstileWidget";
import { resetTurnstileToken } from "../security/turnstile";
import { FlightSelectorFlight } from "../types/intake-funnel";
import { filterDuplicatedFlights, filterIncompleteFlights } from "v2/utils/flightSelectorHelpers";

const FIVE_MINUTES = 5 * 60 * 1000;
const cookies = new Cookies();

const flightSelectorQueryFn = async (
  flightDate: Date | null,
  departureAirportIata: string | undefined,
  arrivalAirportIata: string | undefined,
) => {
  const turnstileToken = cookies.get(TURNSTILE_COOKIE_NAME);

  try {
    const rawFlights = await fetchFlights(
      flightDate,
      departureAirportIata,
      arrivalAirportIata,
      turnstileToken,
    );

    const flights = filterDuplicatedFlights(filterIncompleteFlights(rawFlights)).map((rawFlight) =>
      extractFlightSelectorFlightData(rawFlight),
    ) as FlightSelectorFlight[];

    return flights;
  } catch (error) {
    sendErrorReport(error, "Error on flights fetch");
  } finally {
    resetTurnstileToken();
  }
};
export function useFetchFlights(
  flightDate: Date | null,
  departureAirportIata: string | undefined,
  arrivalAirportIata: string | undefined,
  enabled: boolean = true,
) {
  const { data, isFetching, refetch } = useQuery({
    queryKey: [`flight - ${flightDate}, ${departureAirportIata}, ${arrivalAirportIata}`],
    queryFn: () => flightSelectorQueryFn(flightDate, departureAirportIata, arrivalAirportIata),
    retry: 1,
    staleTime: FIVE_MINUTES,
    enabled: enabled,
  });

  return {
    refetch,
    flights: data || [],
    isFetching,
  };
}
